import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import LinearProgress from '@mui/material/LinearProgress';

export const Card = styled(Box, {
  shouldForwardProp: prop => prop !== 'disabled'
})<{ disabled?: boolean }>(({ theme, disabled }) => ({
  position: 'relative',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '12px',
  width: '100%',
  padding: '20px',
  borderRadius: '16px',
  backgroundColor: theme.palette.neutrals.beige2,
  ...(disabled && {
    pointerEvents: 'none',
    opacity: 0.5
  })
}));

export const HiddenStepper = styled(Stepper)({
  display: 'none'
});

export const FooterProgress = styled(LinearProgress)(({ theme }) => ({
  position: 'absolute',
  left: 0,
  right: 0,
  bottom: 0,
  height: '4px',
  backgroundColor: theme.palette.brand.lightGreen,
  '& .MuiLinearProgress-bar': {
    backgroundColor: theme.palette.brand.mediumGreen
  }
}));
